<template>
  <IconListItem
    align-items="start"
    icon="orders"
    :label="$t('listitem.scratchticketsamount.label')"
  >
    {{ $t('listitem.scratchticketsamount.value', { count: quantity }) }}
    <template v-if="hasCancelledScratchcards">
      <div class="flex items-center text-accent-accent-danger gap-100 mt-100">
        {{
          $t('listitem.scratchticketsamount.canceled.value', {
            count: cancelledScratchcards?.length,
          })
        }}

        <LcInfoButton
          :key="`infobutton_${locale}`"
          :headline="
            $t('listitem.scratchticketsamount.canceled.info.headline', {
              count: cancelledScratchcards?.length,
            })
          "
          :open-button-aria-label="$t('listitem.scratchticketsamount.canceled.info.arialabel')"
        >
          <div>
            <p class="mb-500">
              {{ $t('listitem.scratchticketsamount.canceled.info.text') }}
            </p>
            <div class="flex flex-col gap-100">
              <div
                v-for="cancelledScratchcard in cancelledScratchcards"
                :key="cancelledScratchcard.serialNumber"
                class="serial-number w-full flex bg-secondary-secondary p-100 rounded-m"
              >
                <ScratchcardListItem
                  :label="$t('listitem.scratchticketsamount.canceled.info.serialnumber')"
                >
                  {{ cancelledScratchcard.serialNumber }}
                </ScratchcardListItem>
              </div>
            </div>
          </div>
        </LcInfoButton>
      </div>
    </template>
  </IconListItem>
</template>

<script lang="ts" setup>
import IconListItem from '~/components/IconList/IconListItem.vue'

export type IconListItemScratchcardTicketsAmountProps = {
  cancelledScratchcards?: any[]
  quantity: number
}

const { locale } = useI18n()

const props = defineProps<IconListItemScratchcardTicketsAmountProps>()

const hasCancelledScratchcards = computed(
  () => props.cancelledScratchcards?.length && props.cancelledScratchcards?.length > 0,
)
</script>

<style scoped lang="scss">
.serial-number-label {
  width: 5rem;
}
</style>
